export function filterProductBy(arr, itemField, toMatchedField) {
    return arr.filter(item => item[itemField] === toMatchedField);
}

export function filterMultiServiceCurrentBookingState(state, getters) {
    const otherBookingDetails = getters.GET_ACTIVE_MULTIPLE_SERVICE_OTHER_BOOKING_STATE
        .find(bookingState =>
            bookingState.service_group_id === getters.GET_ACTIVE_SERVICE_GROUP.service_group_id
            && bookingState.service_setting_id === getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id);
    if (otherBookingDetails) {
        return otherBookingDetails.selectedMultipleCollectionSetting;
    } else {
        return null;
    }
}

export function parseNumberFields(obj) {
    const d = { ...obj };
    for (const key in d) {
        if (d.hasOwnProperty(key)) {
            if (['product_pricing_price1', 'product_pricing_price2'].includes(key)) {
                d[key] = parseFloat(d[key]);
            }
        }
    }
    return d;
}